"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReasonInput = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _constants = require("../../../../constants");
var _hooks = require("../../../../hooks");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ReasonInput = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    register
  } = (0, _reactHookForm.useFormContext)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)({
    name: 'reason'
  });
  const reason = (0, _reactHookForm.useWatch)({
    name: 'reason'
  });
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const inputProps = (0, _react.useMemo)(() => ({
    endAdornment: null,
    [_constants.DATA_TEST_ID]: getTestId(_constants2.REASON_INPUT)
  }), [getTestId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledInput, {
    ...register('reason'),
    required: true,
    multiline: true,
    fullWidth: true,
    label: translations.reason,
    value: reason,
    id: "reason",
    minRows: 4,
    maxRows: 4,
    InputProps: inputProps,
    margin: "normal",
    variant: "outlined",
    error: !!errors.reason
  });
};
exports.ReasonInput = ReasonInput;
